import axios from 'axios';
import Loader from "../components/Loader";
import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify';

const ProductDetail = () => {

    const { ProductCode } = useParams();
    const [prodD, setProdD] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const [isAdded, setIsAdded] = useState(false);
    const navigate = useNavigate();

    const getProdD = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}call-third-party`,
                {
                    params: {
                        'url': `${process.env.REACT_APP_BOND_API_URL}WService=BondWSLive/SWDB/jgat0000.w`,
                        'body': {
                            "Event": "search",
                            "UserId": "MV00008",
                            "APIKey": "bFjncidncrcbElCm",
                            "CustomerInformation": {
                                "AccountNumber": "MV00008"
                            },
                            "SearchCriteria": {
                                "ProductCode": ProductCode,
                                "DeliveryMethod": "Deliver",
                                "InStockOnly": true,
                                "FullAttributes": true
                            },
                        },
                    }
                }
            );
            setProdD(res.data.data.Response.Results[0]);
        } catch (err) {
            console.log('Product Detail Fetching Error', err);
        }
    };

    useEffect(() => {
        getProdD();
    }, [ProductCode]);

    const decrease = () => setQuantity(prev => (prev > 1 ? prev - 1 : 1));
    const increase = () => setQuantity(prev => prev + 1);

    const handleAddToCart = () => {
        if (!prodD) return;
        const cart = JSON.parse(localStorage.getItem("cart")) || [];
        const existingIndex = cart.findIndex(item => item.ProductCode === prodD.ProductCode);
        if (existingIndex !== -1) {
            cart[existingIndex].quantity += quantity;
        } else {
            cart.push({
                ProductCode: prodD.ProductCode,
                name: prodD.DescriptionShort,
                price: prodD.VATBondPrice,
                brand: prodD.Attributes?.Brand || '',
                image: 'https://store.mvtyres.com/images/feature01.png',
                quantity,
            });
        }
        localStorage.setItem("cart", JSON.stringify(cart));
        window.dispatchEvent(new Event("cartUpdated"));
        setIsAdded(true);
        setTimeout(() => setIsAdded(false), 700);
        toast.success('Product Added In Cart Successfully!')
        setTimeout(() => {
            navigate('/cart');
        }, 1000)
    };

    useEffect(() => {
        if (!prodD) return;
        const cart = JSON.parse(localStorage.getItem("cart")) || [];
        const existingIndex = cart.findIndex(item => item.ProductCode === prodD.ProductCode);
        if (existingIndex !== -1) {
            cart[existingIndex].quantity = quantity;
            localStorage.setItem("cart", JSON.stringify(cart));
            window.dispatchEvent(new Event("cartUpdated"));
        }
    }, [quantity]);

    if (!prodD) return <Loader />;

    return (
        <>
            <section className="inner-banner">
                <div className="container-fluid web-padding">
                    <div className="row">
                        <div className="col-md-6" data-aos="flip-left" data-aos-duration={2000}>
                            <div className="inner-banner-left">
                                <h1>products Detail</h1>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="inner-banner-right">
                                <img src="../images/hero-tires.png" alt="img" />
                            </div>
                        </div>
                    </div>
                </div>
                <h2>Tyres</h2>
            </section>
            <section className="single-product">
                <div className="container-fluid web-padding">
                    <div className="row">
                        <div className="col-md-6" data-aos="fade-right" data-aos-duration={2000}>
                            <div className="single-product-left">
                                <img src="../images/feature01.png" alt="img" />
                            </div>
                        </div>
                        <div className="col-md-6" data-aos="fade-left" data-aos-duration={2000}>
                            <div className="single-product-right">
                                <h3 className='pb-0'>{prodD.DescriptionShort}</h3>
                                <h3 className='pt-0'>£{prodD.VATBondPrice}</h3>
                                <ul className='dlt_wrpr'>
                                    <li><span>Brand</span><strong>{prodD.Attributes.Brand}</strong></li>
                                    <li><span>Brand Category</span><strong>{prodD.Attributes.BrandCategory}</strong></li>
                                    <li><span>Category</span><strong>{prodD.Attributes.Category}</strong></li>
                                    <li><span>Fuel Efficiency Rating</span><strong>{prodD.Attributes.FuelEfficiencyRating}</strong></li>
                                    <li><span>Ice Grip</span><strong>{prodD.Attributes.IceGrip === false ? "No" : "Yes"}</strong></li>
                                    <li><span>Noise Rating Class</span><strong>{prodD.Attributes.NoiseRatingClass}</strong></li>
                                    <li><span>Season</span><strong>{prodD.Attributes.Season}</strong></li>
                                    <li><span>Snow Grip</span><strong>{prodD.Attributes.SnowGrip === false ? "No" : "Yes"}</strong></li>
                                    <li><span>Wet Grip Rating</span><strong>{prodD.Attributes.WetGripRating}</strong></li>
                                </ul>
                                <div className="wuanity-increasedec-wrapper">
                                    <div className="single-product-names">
                                        <p className='d-flex gap-1'>Availability : <strong>In Stock</strong></p>
                                    </div>
                                    <div className="quanity-wrapper">
                                        <p>quantity</p>
                                        <div>
                                            <div>
                                                <button
                                                    type="button"
                                                    className="product-decrease"
                                                    onClick={decrease}
                                                >
                                                    <i className="fa-solid fa-minus" />
                                                </button>
                                                <h6 className="total-added-products">{quantity}</h6>
                                                <button
                                                    type="button"
                                                    className="product-increase"
                                                    onClick={increase}
                                                >
                                                    <i className="fa-solid fa-plus" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="product-dt-social-wrapper">
                                <div className="footer-social">
                                    <Link to=""><i className="fa-brands fa-facebook-f" /></Link>
                                    <Link to=""><i className="fa-brands fa-x-twitter" /></Link>
                                    <Link to=""><i className="fa-brands fa-instagram" /></Link>
                                    <Link to=""><i className="fa-brands fa-linkedin-in" /></Link>
                                </div>
                                {/* <Link to="/cart" className="theme-btn">add to cart<span><img src="../images/arrow-right.png" alt="icon" /></span></Link> */}
                                <button
                                    onClick={handleAddToCart}
                                    className="theme-btn cart_btn"
                                >
                                    {isAdded ? "Adding..." : "Add to Cart"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <div className="product-description-wrapper">
                <div className="product-desc">
                    <div className="container-fluid web-padding wow fadeInUp" data-wow-duration="2s">
                        <ul className="nav nav-tabs " id="myTab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button className="nav-link active" id="desc-tab" data-bs-toggle="tab" data-bs-target="#desc" type="button" role="tab" aria-controls="desc" aria-selected="true">Description</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="info-tab" data-bs-toggle="tab" data-bs-target="#info" type="button" role="tab" aria-controls="info" aria-selected="false">Additional Information</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="reviews-tab" data-bs-toggle="tab" data-bs-target="#reviews" type="button" role="tab" aria-controls="reviews" aria-selected="false">Reviews (4)</button>
                            </li>
                        </ul>
                        <div className="tab-content p-4" id="myTabContent">
                            <div className="tab-pane fade show active" id="desc" role="tabpanel" aria-labelledby="desc-tab">
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut
                                    labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
                                    laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in
                                    voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                                    cupidatat
                                    non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                                <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque
                                    laudantium,
                                    totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae
                                    vitae
                                    dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut
                                    fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque
                                    porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed
                                    quia
                                    non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat
                                    voluptatem.
                                </p>
                            </div>
                            <div className="tab-pane fade" id="info" role="tabpanel" aria-labelledby="info-tab">
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut
                                    labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
                                    laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in
                                    voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                                    cupidatat
                                    non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                                <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque
                                    laudantium,
                                    totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae
                                    vitae
                                    dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut
                                    fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque
                                    porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed
                                    quia
                                    non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat
                                    voluptatem.
                                </p>
                            </div>
                            <div className="tab-pane fade" id="reviews" role="tabpanel" aria-labelledby="reviews-tab">
                                <form action="#">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <input type="text" placeholder="First Name" />
                                        </div>
                                        <div className="col-md-6">
                                            <input type="text" placeholder="Your Email" />
                                        </div>
                                        <div className="col-md-6">

                                        </div>
                                        <div className="col-md-12">
                                            <textarea placeholder="Write Your Review" rows={10} defaultValue={""} />
                                            <div className="rev-btn">
                                                <div className="form-group col-md-12">
                                                    <label className="d-block">
                                                        <h6>Give Review</h6>
                                                    </label>
                                                    <div className="rate">
                                                        <input type="radio" id="star5" name="rating" defaultValue={5} />
                                                        <label htmlFor="star5" className="lblb" title="text">5 stars</label>
                                                        <input type="radio" id="star4" name="rating" defaultValue={4} />
                                                        <label htmlFor="star4" className="lblb" title="text">4 stars</label>
                                                        <input type="radio" id="star3" name="rating" defaultValue={3} />
                                                        <label htmlFor="star3" className="lblb" title="text">3 stars</label>
                                                        <input type="radio" id="star2" name="rating" defaultValue={2} />
                                                        <label htmlFor="star2" className="lblb" title="text">2 stars</label>
                                                        <input type="radio" id="star1" name="rating" defaultValue={1} />
                                                        <label htmlFor="star1" className="lblb" title="text">1 star</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="review-btn">
                                            <button type="submit" className="theme-btn-1">Submit</button>
                                        </div>
                                    </div>
                                </form>
                                <div className="testimonial-container prd-commets">
                                    <div className="testi-box">
                                        <div className="box-top">
                                            <div className="profile">
                                                <div className="profile-img">
                                                    <img src="../images/testi-man01.jpg" />
                                                </div>
                                                <div className="name-user">
                                                    <strong>Liam mendes</strong>
                                                    <span>@liammendes</span>
                                                </div>
                                            </div>
                                            <div className="reviews">
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                                <i className="far fa-star" />
                                            </div>
                                        </div>
                                        <div className="client-comment">
                                            <p>
                                                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                                Exercitationem, quaerat quis? Provident temporibus
                                                architecto asperiores nobis maiores nisi a. Quae
                                                doloribus ipsum aliquam tenetur voluptates incidunt
                                                blanditiis sed atque cumque.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="testi-box">
                                        <div className="box-top">
                                            <div className="profile">
                                                <div className="profile-img">
                                                    <img src="../images/testi-man02.jpg" />
                                                </div>
                                                <div className="name-user">
                                                    <strong>Noah Wood</strong>
                                                    <span>@noahwood</span>
                                                </div>
                                            </div>
                                            <div className="reviews">
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                            </div>
                                        </div>
                                        <div className="client-comment">
                                            <p>
                                                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                                Exercitationem, quaerat quis? Provident temporibus
                                                architecto asperiores nobis maiores nisi a. Quae
                                                doloribus ipsum aliquam tenetur voluptates incidunt
                                                blanditiis sed atque cumque.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="testi-box">
                                        <div className="box-top">
                                            <div className="profile">
                                                <div className="profile-img">
                                                    <img src="../images/testi-man03.jpg" />
                                                </div>
                                                <div className="name-user">
                                                    <strong>Oliver Queen</strong>
                                                    <span>@oliverqueen</span>
                                                </div>
                                            </div>
                                            <div className="reviews">
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                                <i className="far fa-star" />
                                            </div>
                                        </div>
                                        <div className="client-comment">
                                            <p>
                                                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                                Exercitationem, quaerat quis? Provident temporibus
                                                architecto asperiores nobis maiores nisi a. Quae
                                                doloribus ipsum aliquam tenetur voluptates incidunt
                                                blanditiis sed atque cumque.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    )
}

export default ProductDetail